import React from 'react'

import { Button, Card, OptionsGroup, SelectInput } from '@fielded/shared-ui'
import { CloseCircle } from '@fielded/shared-ui/src/icons'

const CarrierManagementServiceAreaItem = ({
  serviceArea,
  index,
  stateOptions,
  onHandleServiceAreaChange,
  onRemoveServiceArea,
  canBeRemoved,
  viewOnly,
  attemptedServiceAreaIndices
}) => {
  // Check if this specific service area item has been part of a form submission attempt.
  // We track individual indices rather than a global boolean to ensure that:
  // 1. Only service areas that existed during a submit attempt show validation errors
  // 2. Newly added service areas after a failed submission don't immediately show errors
  // 3. Users can add new service areas without seeing premature error states
  const hasAttemptedSubmit = attemptedServiceAreaIndices.has(index)

  return (
    <Card
      rounded
      semitight
      key={index}
      className='carrier-management__service-card'
    >
      {canBeRemoved && (
        <Button
          icon={<CloseCircle />}
          size='large'
          className='carrier-management__remove-btn'
          onClick={() => onRemoveServiceArea(index)}
        />
      )}
      <SelectInput.Stateless
        clearable={false}
        value={serviceArea.state}
        options={stateOptions}
        onValueChange={(value) => onHandleServiceAreaChange(index, value, 'state')}
        disabled={viewOnly}
        hasError={hasAttemptedSubmit && serviceArea.state === ''}
      />
      <OptionsGroup.Stateless
        label='Set priority to state'
        options={[
          {
            value: 'primary',
            label: 'Primary'
          },
          {
            value: 'secondary',
            label: 'Secondary'
          },
          {
            value: 'tertiary',
            label: 'Tertiary'
          }
        ]}
        value={serviceArea.priority}
        onValueChange={(value) => onHandleServiceAreaChange(index, value, 'priority')}
        disabled={viewOnly}
        hasError={hasAttemptedSubmit && serviceArea.priority === ''}
      />
    </Card>
  )
}

export default CarrierManagementServiceAreaItem
